<template>
  <div class="collect-log-container">
    <div class="collect-log-back">
      <el-button @click="goBack" type="primary" size="mini"><jee-icon iconClass="fanhui"></jee-icon> 返回</el-button>
    </div>
    <div class="collect-log-box">
      <h3>{{ collectDetail.modelType !== '' ? '快速采集' : '自定义采集'}}</h3>
      <div class="collect-log-top">
        <div class="collect-log-top-link">
          <el-input size="small" v-model="urlModel" :disabled="true"></el-input>
        </div>
        <div class="collect-log-top-action">
          <el-button type="primary" size="small" v-if="collectDetail.status !== 2" :disabled="collectDetail.status !== 1" @click="suspend">暂停</el-button>
          <el-button type="primary" size="small" v-if="collectDetail.status === 2" @click="recovery">开始</el-button>
          <el-button type="primary" size="small" :disabled="collectDetail.status !== 1" @click="finish">结束</el-button>
        </div>
      </div>
      <div class="collect-log-tab">
        <el-tabs type="card" v-model="currentTab">
          <template v-for="(tab, index) in tabs">
            <el-tab-pane :name="tab.name" :key="index">
              <label slot="label" style="cursor: pointer;">{{tab.label}}</label>
              <component :detail="collectDetail" :id="collectId" :is="tab.component" :name="currentTab" :key="index" :end="finish"/>
            </el-tab-pane>
          </template>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import baseTable from '@/components/mixins/baseTable'
import CollectLogList from './components/CollectLogLists'

export default {
  name: 'CollectLog',
  mixins: [baseTable],
  components: {
    CollectLogList
  },
  data () {
    return {
      collectDetail: {}, // 采集详情    status 0未开始  1 运行中 2暂停  3已结束
      collectId: '', // ID
      currentTab: 'logs', // tab切换
      tabs: [
        {
          label: '运行日志',
          name: 'logs',
          showAlert: true,
          content: '运行日志',
          component: 'CollectLogList'
        }
      ]
    }
  },
  computed: {
    urlModel () {
      return this.collectDetail.collectUrl === '' ? this.collectDetail.keyword : this.collectDetail.collectUrl
    }
  },
  mounted () {
    this.collectId = this.$route.query.taskId
    this.getCollectDatel()
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    // 获取采集详情
    getCollectDatel () {
      this.$request.fetchCollectTaskDetail(this.collectId).then(res => {
        if (res.code === 200) {
          this.collectDetail = res.data
          setTimeout(() => {
            window.parent.postMessage({ taskId: this.collectId }, '*')
          }, 2500)
        }
      })
    },
    // 暂停
    suspend () {
      this.$request.fetchCollectPause(this.collectId).then(res => {
        if (res.code === 200) {
          this.collectDetail.status = 2
        }
      })
    },
    // 恢复
    recovery () {
      this.$request.fetchCollectRecover(this.collectId).then(res => {
        if (res.code === 200) {
          this.collectDetail.status = 1
        }
      })
    },
    // 结束
    finish () {
      this.$request.fetchCollectStop(this.collectId).then(res => {
        if (res.code === 200) {
          this.collectDetail.status = 3
        }
      })
    }
  }
}
</script>

<style lang="scss">
.collect-log-container{
  .collect-log-back{
    margin-bottom: 20px;
    .el-button{
      font-size:16px;
      width: 90px;
      padding: 9px 0;
    }
    .jee-svg-icon{
      vertical-align: -0.1em;
      font-size: 14px;
    }
  }

  .collect-log-box{
    h3{
      font-size:18px;
      font-weight:normal;
      color:rgba(51,51,51,1);
      margin-bottom: 30px;
    }
    .collect-log-top{
      display: flex;
      margin-bottom: 20px;
      .collect-log-top-link{
        font-size:14px;
        flex: 1;
      }
      .collect-log-top-action{
        /deep/ .el-button{
          width: 77px;
          height: 32px;
          margin-left: 10px;
        }
      }
    }
    .collect-log-tab{
      height: 100%;
      margin-bottom: 30px;
      /deep/ .el-tabs__header .el-tabs__item:last-child{
        padding: 0;
        width: 105px;
        text-align: center;
      }
    }
  }
}
</style>
